import * as type from '../constants/ActionTypes';

export default function salesGroups(
  state = {},
  action
) {
  switch (action.type) {
    case type.SALES_GROUP_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      });
    case type.SALES_GROUP_SUCCESS:

      const sgs = [];

      action.response.map( sg => sgs.push({id:sg.salesGroupId, name:sg.name}));

      return Object.assign({}, state, {
        isFetching: false,
        salesGroupIdList: sgs
      });
    case type.SALES_GROUP_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      });
    default:
      return state;
  }
}
